import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setApplicationModule } from "../../../actions/appActions";
import { ApplicationModule } from "../../../utils/models/applicationModules";
import {
	RestrictedCompanyAccountType,
	navigationsForGalkRecruit,
} from "../../../utils/constants";
import { getCompanyAccountType } from "../../../reducers/companySelector";
import { withRouter, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu } from "antd";
import "./leftBottom.css";

const LeftBottom = ({
	location,
	appModule,
	match,
	setApplicationModule,
	userId,
	companyAccountType,
}) => {
	const { t } = useTranslation();
	const isRestrictedAccountType =
		RestrictedCompanyAccountType.includes(companyAccountType);

	const internshipPages = navigationsForGalkRecruit.map((item, i) => {
		return {
			title: `${t(item.translateKey)}`,
			href: `/Internship${item.relativeUrl}`,
			icon: item.icon,
			key: item.key,
		};
	});

	return (
		<>
			{userId && (
				<Menu selectedKeys={[location.pathname.split("/")[2]]}>
					{internshipPages.map((item, i) => (
						<Menu.Item key={item.key} icon={item.icon}>
							<Link to={item.href}>
								<span className="leftmenu_linkText">{item.title} </span>
							</Link>
						</Menu.Item>
					))}
				</Menu>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	userId: state.firebase.auth.uid,
	appModule: state.app.appModule,
	companyAccountType: getCompanyAccountType(state),
});

export default connect(mapStateToProps, { setApplicationModule })(
	withRouter(LeftBottom)
);
